module.exports = __webpack_public_path__ + "resources/756c7885cca3251f091065a561a180b3.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/oversized-super-hero.png
// module id = 215
// module chunks = 0